import { render, staticRenderFns } from "./SelectorMenuDivider.vue?vue&type=template&id=548f60b7&scoped=true"
import script from "./SelectorMenuDivider.vue?vue&type=script&lang=js"
export * from "./SelectorMenuDivider.vue?vue&type=script&lang=js"
import style0 from "./SelectorMenuDivider.vue?vue&type=style&index=0&id=548f60b7&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "548f60b7",
  null
  
)

export default component.exports